import React from "react";

// Need SVG logos for dynamic fill when toggling dark mode
export const LogoMobile = () => {
  return (
    <svg
      className="logo-mobile"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 174.32 62.49"
    >
      <g>
        <g>
          <polygon
            className="cls-1"
            points="15.22,26 6.13,38.66 12.88,38.66 18.8,30.79"
          />
          <polygon
            className="cls-1"
            points="37.93,33.19 27.44,19.3 37.87,5.47 33.8,0.06 23.65,14.22 12.99,0 6.19,0 33.86,38.6 		"
          />
          <polygon
            className="cls-3"
            points="25.88,0 20.02,7.75 23.65,12.55 32.69,0 		"
          />
          <polygon
            className="cls-3"
            points="25.94,38.66 32.74,38.66 5.02,0.06 1,5.47 11.38,19.3 1,33.08 4.96,38.6 15.17,24.32 		"
          />
          <path
            className="cls-1"
            d="M47.36,31.13c-3.17,0.06-6.22-1.24-8.37-3.57c-1-1.1-1.78-2.39-2.29-3.79c-1.69-4.4-0.78-9.37,2.34-12.89
            c1.02-1.09,2.26-1.97,3.63-2.57c1.47-0.67,3.07-1,4.69-0.95c3.17-0.06,6.22,1.24,8.37,3.57c1.02,1.1,1.81,2.39,2.34,3.79
            c0.56,1.46,0.84,3.01,0.84,4.57c0.01,1.55-0.28,3.08-0.84,4.52c-1.1,2.83-3.26,5.11-6.02,6.36C50.56,30.8,48.97,31.13,47.36,31.13
            z M39.77,19.3c-0.02,1.15,0.19,2.28,0.61,3.35c0.36,0.99,0.91,1.9,1.62,2.68c0.69,0.73,1.5,1.34,2.4,1.79
            c1.87,0.89,4.04,0.89,5.91,0c0.93-0.45,1.77-1.07,2.45-1.84c0.73-0.79,1.28-1.72,1.62-2.73c0.4-1.07,0.6-2.2,0.61-3.35
            c0.02-1.13-0.19-2.25-0.61-3.29c-0.4-0.99-0.94-1.91-1.62-2.73c-0.68-0.78-1.52-1.41-2.45-1.84c-0.92-0.44-1.93-0.67-2.96-0.67
            c-1.02-0.01-2.04,0.22-2.96,0.67c-0.91,0.45-1.73,1.07-2.4,1.84c-0.71,0.8-1.26,1.73-1.62,2.73C40,16.99,39.79,18.14,39.77,19.3z"
          />
          <path
            className="cls-1"
            d="M95.78,30.68h-3.85V17.85c0-2.4-0.39-4.18-1.17-5.3c-0.78-1.13-2.09-1.78-3.46-1.73
            c-1.57,0.01-3.08,0.61-4.24,1.67c-1.27,1.18-2.2,2.68-2.68,4.35v13.83h-3.85V17.85c0-2.45-0.39-4.24-1.12-5.36
            c-0.77-1.1-2.06-1.73-3.4-1.67c-1.55,0.01-3.03,0.59-4.18,1.62c-1.34,1.16-2.29,2.69-2.73,4.41v13.83h-3.85V7.81h3.51v4.91
            c0.84-1.6,2.09-2.95,3.63-3.9c1.51-0.93,3.25-1.42,5.02-1.39c1.67-0.11,3.32,0.45,4.57,1.56c1.14,1.05,1.87,2.47,2.06,4.02
            c2.06-3.74,4.96-5.58,8.7-5.58c1.14-0.04,2.27,0.21,3.29,0.73c0.88,0.46,1.62,1.15,2.12,2.01c0.57,0.94,0.95,1.98,1.12,3.07
            c0.22,1.25,0.34,2.52,0.33,3.79L95.78,30.68L95.78,30.68z"
          />
          <path
            className="cls-1"
            d="M109.95,31.13c-1.63,0.02-3.25-0.3-4.74-0.95c-1.39-0.6-2.64-1.47-3.68-2.57c-1.03-1.1-1.85-2.39-2.4-3.79
            c-1.12-2.95-1.12-6.2,0-9.15c1.75-4.43,6.06-7.32,10.82-7.25c4.71-0.06,8.95,2.84,10.6,7.25c0.56,1.4,0.83,2.9,0.78,4.41v0.89
            c0,0.22-0.06,0.39-0.06,0.61H102.3c0.07,1.08,0.33,2.14,0.78,3.12c0.41,0.91,1,1.72,1.73,2.4c0.68,0.68,1.5,1.22,2.4,1.56
            c0.9,0.38,1.87,0.57,2.84,0.56c0.7-0.01,1.39-0.11,2.06-0.28c0.66-0.18,1.3-0.44,1.9-0.78c0.56-0.33,1.09-0.72,1.56-1.17
            c0.43-0.45,0.78-0.98,1-1.56l3.35,0.95c-0.4,0.86-0.92,1.65-1.56,2.34c-0.67,0.72-1.44,1.34-2.29,1.84
            c-0.9,0.55-1.88,0.96-2.9,1.23C112.11,30.99,111.03,31.11,109.95,31.13z M117.81,17.74c-0.12-2.04-1.02-3.96-2.51-5.36
            c-2.2-2.02-5.37-2.6-8.14-1.51c-0.89,0.36-1.71,0.89-2.4,1.56c-0.71,0.66-1.28,1.46-1.67,2.34c-0.42,0.94-0.69,1.93-0.78,2.96
            L117.81,17.74z"
          />
          <path
            className="cls-1"
            d="M136.11,29.51l-0.89,0.45c-0.39,0.17-0.84,0.33-1.28,0.5c-0.45,0.17-1.04,0.28-1.56,0.39
            c-0.59,0.11-1.19,0.17-1.79,0.17c-1.31,0.03-2.59-0.38-3.63-1.17c-1.07-0.87-1.65-2.2-1.56-3.57V10.82h-3.12V7.81h3.12V0.17h3.85
            v7.64h5.13v3.01h-5.13v14.17c-0.02,0.71,0.29,1.39,0.84,1.84c0.5,0.37,1.11,0.57,1.73,0.56c0.71,0.01,1.41-0.12,2.06-0.39
            c0.45-0.15,0.88-0.35,1.28-0.61L136.11,29.51z"
          />
          <path
            className="cls-1"
            d="M150.67,11.16c-1.8,0.02-3.56,0.54-5.08,1.51c-1.46,0.9-2.56,2.28-3.12,3.9v14.11h-3.85V7.81h3.57v5.3
            c0.73-1.51,1.8-2.82,3.12-3.85c1.17-0.93,2.58-1.51,4.07-1.67h0.73c0.17-0.01,0.34,0.01,0.5,0.06L150.67,11.16L150.67,11.16z"
          />
          <path
            className="cls-1"
            d="M157.08,35.03c0.37,0.07,0.74,0.1,1.12,0.11c0.39,0,0.67,0.06,0.89,0.06c0.86,0.06,1.67-0.43,2.01-1.23
            c0.51-1.07,0.95-2.17,1.34-3.29l-9.65-22.87h3.96l7.81,19.41l7.08-19.41h3.68l-10.43,27c-0.42,1.05-1.11,1.98-2.01,2.68
            c-1.13,0.82-2.51,1.24-3.9,1.17c-0.28,0.01-0.56-0.01-0.84-0.06l-1-0.17L157.08,35.03z"
          />
          <path
            className="cls-1"
            d="M168.51,31.35c0-0.6,0.32-1.15,0.84-1.45c0.25-0.15,0.54-0.22,0.84-0.22c0.92,0,1.67,0.75,1.67,1.67
            c0,0.29-0.07,0.57-0.21,0.83c-0.3,0.53-0.86,0.85-1.46,0.85c-0.6,0-1.16-0.32-1.46-0.85C168.59,31.92,168.51,31.64,168.51,31.35z
            M168.79,31.35c-0.01,0.77,0.61,1.39,1.38,1.4c0.01,0,0.01,0,0.02,0c0.25,0,0.49-0.06,0.71-0.19c0.21-0.12,0.39-0.3,0.51-0.51
            c0.12-0.21,0.19-0.45,0.18-0.7c0-0.24-0.06-0.49-0.18-0.7c-0.12-0.21-0.3-0.39-0.51-0.51c-0.43-0.25-0.96-0.25-1.39,0
            c-0.21,0.12-0.39,0.3-0.51,0.51C168.86,30.86,168.79,31.11,168.79,31.35z M170.87,30.95c0.02,0.23-0.12,0.44-0.34,0.52l0.56,0.89
            h-0.5l-0.42-0.77h-0.2v0.76h-0.42v-2.01h0.56c0.2-0.01,0.39,0.04,0.56,0.15C170.79,30.61,170.87,30.78,170.87,30.95z
            M169.96,31.27h0.16c0.09,0.01,0.18-0.02,0.25-0.08c0.06-0.06,0.09-0.14,0.08-0.22c0.01-0.08-0.02-0.16-0.08-0.22
            c-0.08-0.05-0.17-0.07-0.26-0.07h-0.15V31.27z"
          />
        </g>
        <g>
          <path
            className="cls-1"
            d="M23.11,52.01L21,59.44h-1.19l-1.46-4.73c-0.04-0.12-0.08-0.26-0.12-0.41c-0.04-0.15-0.08-0.29-0.12-0.43
            c-0.04-0.14-0.07-0.27-0.1-0.39c-0.03-0.12-0.04-0.2-0.05-0.26c-0.01,0.06-0.02,0.15-0.05,0.26c-0.02,0.11-0.05,0.24-0.08,0.38
            s-0.07,0.29-0.11,0.43c-0.04,0.15-0.08,0.29-0.12,0.42l-1.43,4.72h-1.18l-2.1-7.43h1.14l1.22,4.51c0.04,0.15,0.08,0.3,0.12,0.46
            s0.07,0.31,0.11,0.46c0.03,0.15,0.06,0.3,0.09,0.45s0.05,0.28,0.07,0.41c0.02-0.13,0.04-0.27,0.07-0.42
            c0.03-0.15,0.06-0.3,0.1-0.46c0.03-0.16,0.07-0.31,0.11-0.46c0.04-0.15,0.08-0.3,0.13-0.44l1.37-4.5h1.12l1.42,4.52
            c0.04,0.14,0.09,0.29,0.13,0.45c0.04,0.16,0.08,0.31,0.12,0.47c0.03,0.16,0.07,0.3,0.09,0.45s0.05,0.27,0.07,0.4
            c0.03-0.17,0.06-0.35,0.1-0.55s0.08-0.4,0.13-0.61c0.05-0.21,0.1-0.42,0.15-0.62l1.22-4.5H23.11z"
          />
          <path
            className="cls-1"
            d="M30.5,59.44h-1.12v-3.43h-3.94v3.43h-1.12v-7.43h1.12v3.1h3.94v-3.1h1.12V59.44z"
          />
          <path
            className="cls-1"
            d="M37.02,59.44h-4.49v-7.43h4.49v0.89h-3.37v2.21h3.17V56h-3.17v2.54h3.37V59.44z"
          />
          <path
            className="cls-1"
            d="M40.8,52.01c0.67,0,1.23,0.08,1.67,0.23c0.44,0.15,0.77,0.39,0.98,0.7s0.32,0.71,0.32,1.19
            c0,0.38-0.07,0.7-0.22,0.96s-0.35,0.47-0.59,0.64c-0.24,0.17-0.5,0.3-0.78,0.39l2.24,3.31h-1.29l-1.95-3.04h-1.47v3.04H38.6v-7.43
            H40.8z M40.73,52.9h-1.01v2.64h1.09c0.63,0,1.09-0.11,1.38-0.34c0.29-0.23,0.44-0.57,0.44-1.01c0-0.46-0.16-0.79-0.46-0.99
            S41.37,52.9,40.73,52.9z"
          />
          <path
            className="cls-1"
            d="M50.12,59.44h-4.49v-7.43h4.49v0.89h-3.37v2.21h3.17V56h-3.17v2.54h3.37V59.44z"
          />
          <path
            className="cls-1"
            d="M53.68,52.01h2.49c1.13,0,1.96,0.15,2.47,0.45c0.51,0.3,0.77,0.78,0.77,1.43c0,0.44-0.11,0.81-0.34,1.09
            c-0.22,0.29-0.52,0.46-0.89,0.51v0.05c0.51,0.11,0.87,0.3,1.1,0.59c0.22,0.29,0.34,0.67,0.34,1.15c0,0.68-0.26,1.21-0.79,1.58
            c-0.53,0.38-1.24,0.57-2.15,0.57h-2.99V52.01z M55.37,54.96h0.98c0.46,0,0.79-0.07,1-0.2c0.21-0.13,0.31-0.35,0.31-0.66
            c0-0.28-0.11-0.49-0.34-0.61c-0.22-0.12-0.58-0.19-1.06-0.19h-0.89V54.96z M55.37,56.21v1.94h1.11c0.47,0,0.81-0.08,1.03-0.25
            s0.33-0.42,0.33-0.76c0-0.62-0.47-0.92-1.42-0.92H55.37z"
          />
          <path className="cls-1" d="M61.17,59.44v-7.43h1.7v7.43H61.17z" />
          <path
            className="cls-1"
            d="M67.82,55.27h3.17v3.85c-0.51,0.16-1,0.27-1.45,0.33s-0.92,0.09-1.39,0.09c-1.21,0-2.13-0.33-2.77-0.99
            s-0.95-1.61-0.95-2.84c0-1.2,0.37-2.13,1.11-2.8c0.74-0.67,1.76-1.01,3.07-1.01c0.82,0,1.61,0.15,2.37,0.46l-0.56,1.26
            c-0.58-0.27-1.19-0.41-1.82-0.41c-0.73,0-1.32,0.23-1.76,0.69s-0.66,1.07-0.66,1.84c0,0.81,0.18,1.42,0.53,1.85
            c0.36,0.43,0.87,0.64,1.55,0.64c0.35,0,0.71-0.03,1.08-0.1v-1.55h-1.52V55.27z"
          />
          <path className="cls-1" d="M75.05,59.44v-7.43h1.7v7.43H75.05z" />
          <path
            className="cls-1"
            d="M85.29,55.66c0,1.22-0.37,2.16-1.12,2.81c-0.75,0.65-1.83,0.98-3.25,0.98h-2.26v-7.43h2.51
            c1.31,0,2.32,0.32,3.04,0.96C84.93,53.62,85.29,54.51,85.29,55.66z M83.53,55.7c0-1.6-0.76-2.39-2.28-2.39h-0.9v4.84h0.73
            C82.72,58.14,83.53,57.33,83.53,55.7z"
          />
          <path
            className="cls-1"
            d="M91.44,59.44h-4.61v-7.43h4.61v1.29h-2.91v1.63h2.71v1.29h-2.71v1.92h2.91V59.44z"
          />
          <path
            className="cls-1"
            d="M98.25,59.44l-0.58-1.77h-2.92l-0.58,1.77h-1.83l2.82-7.46h2.07l2.83,7.46H98.25z M97.26,56.35
            c-0.54-1.6-0.84-2.51-0.91-2.72c-0.07-0.21-0.12-0.38-0.15-0.5c-0.12,0.43-0.46,1.51-1.03,3.22H97.26z"
          />
          <path
            className="cls-1"
            d="M106.09,57.38c0,0.67-0.26,1.2-0.78,1.58c-0.52,0.39-1.24,0.58-2.17,0.58c-0.85,0-1.61-0.15-2.26-0.45v-1.46
            c0.54,0.22,1,0.38,1.37,0.47c0.37,0.09,0.72,0.14,1.03,0.14c0.37,0,0.66-0.07,0.86-0.2c0.2-0.13,0.3-0.33,0.3-0.59
            c0-0.15-0.04-0.28-0.13-0.39c-0.09-0.11-0.22-0.22-0.38-0.33c-0.17-0.11-0.52-0.27-1.04-0.5c-0.49-0.21-0.86-0.42-1.1-0.61
            s-0.44-0.42-0.58-0.69c-0.15-0.26-0.22-0.57-0.22-0.91c0-0.66,0.24-1.17,0.72-1.55c0.48-0.38,1.14-0.56,1.99-0.56
            c0.42,0,0.81,0.05,1.19,0.14c0.38,0.09,0.77,0.22,1.18,0.39l-0.55,1.22c-0.43-0.16-0.78-0.28-1.06-0.34
            c-0.28-0.06-0.55-0.1-0.82-0.1c-0.32,0-0.57,0.07-0.74,0.21c-0.17,0.14-0.26,0.32-0.26,0.54c0,0.14,0.03,0.26,0.1,0.36
            s0.18,0.2,0.33,0.3s0.51,0.27,1.08,0.52c0.75,0.33,1.26,0.67,1.54,1C105.95,56.49,106.09,56.9,106.09,57.38z"
          />
          <path
            className="cls-1"
            d="M115.01,59.44l-0.89-2.21h-3.13l-0.88,2.21h-1.17l3.05-7.46h1.15l3.04,7.46H115.01z M113.81,56.33l-0.84-2.19
            c-0.03-0.08-0.06-0.19-0.12-0.34c-0.05-0.15-0.11-0.3-0.16-0.46c-0.05-0.16-0.1-0.29-0.13-0.4c-0.04,0.14-0.08,0.29-0.13,0.44
            c-0.05,0.15-0.09,0.3-0.14,0.43s-0.08,0.24-0.11,0.32l-0.85,2.19H113.81z"
          />
          <path
            className="cls-1"
            d="M119.53,52.01c0.67,0,1.23,0.08,1.67,0.23c0.44,0.15,0.77,0.39,0.98,0.7s0.32,0.71,0.32,1.19
            c0,0.38-0.07,0.7-0.22,0.96s-0.35,0.47-0.59,0.64c-0.24,0.17-0.5,0.3-0.78,0.39l2.24,3.31h-1.29l-1.95-3.04h-1.47v3.04h-1.12
            v-7.43H119.53z M119.46,52.9h-1.01v2.64h1.09c0.63,0,1.09-0.11,1.38-0.34c0.29-0.23,0.44-0.57,0.44-1.01
            c0-0.46-0.16-0.79-0.46-0.99S120.11,52.9,119.46,52.9z"
          />
          <path
            className="cls-1"
            d="M128.85,59.44h-4.49v-7.43h4.49v0.89h-3.37v2.21h3.17V56h-3.17v2.54h3.37V59.44z"
          />
          <path
            className="cls-1"
            d="M132.38,52.01h2.49c1.13,0,1.96,0.15,2.47,0.45c0.51,0.3,0.77,0.78,0.77,1.43c0,0.44-0.11,0.81-0.34,1.09
            c-0.22,0.29-0.52,0.46-0.89,0.51v0.05c0.51,0.11,0.87,0.3,1.1,0.59c0.22,0.29,0.34,0.67,0.34,1.15c0,0.68-0.26,1.21-0.79,1.58
            c-0.53,0.38-1.24,0.57-2.15,0.57h-2.99V52.01z M134.07,54.96h0.98c0.46,0,0.79-0.07,1-0.2c0.21-0.13,0.31-0.35,0.31-0.66
            c0-0.28-0.11-0.49-0.34-0.61c-0.22-0.12-0.58-0.19-1.06-0.19h-0.89V54.96z M134.07,56.21v1.94h1.11c0.47,0,0.81-0.08,1.03-0.25
            s0.33-0.42,0.33-0.76c0-0.62-0.47-0.92-1.42-0.92H134.07z"
          />
          <path
            className="cls-1"
            d="M146.33,52.01v4.81c0,0.55-0.13,1.03-0.4,1.44c-0.26,0.41-0.65,0.73-1.15,0.95c-0.5,0.22-1.09,0.33-1.77,0.33
            c-1.03,0-1.83-0.24-2.4-0.73c-0.57-0.49-0.85-1.16-0.85-2.01v-4.79h1.69v4.55c0,0.57,0.12,0.99,0.37,1.26s0.66,0.4,1.23,0.4
            c0.55,0,0.96-0.13,1.21-0.4c0.25-0.27,0.38-0.69,0.38-1.27v-4.54H146.33z"
          />
          <path className="cls-1" d="M148.21,59.44v-7.43h1.7v7.43H148.21z" />
          <path
            className="cls-1"
            d="M151.82,59.44v-7.43h1.7v6.13h3.24v1.3H151.82z"
          />
          <path
            className="cls-1"
            d="M160.44,59.44h-1.7v-6.12h-2.17v-1.31h6.04v1.31h-2.17V59.44z"
          />
        </g>
      </g>
    </svg>
  );
};

export const LogoDesktop = () => {
  return (
    <svg
      className="logo-desktop"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 15"
    >
      <path
        className="cls-1 tagline"
        d="M96.39,3.14,94,11.7H92.59L90.91,6.25c0-.14-.1-.3-.14-.46s-.09-.34-.14-.5l-.11-.45c0-.14,0-.24-.06-.31s0,.17-.06.3-.06.28-.09.45-.08.33-.13.5-.09.33-.14.48L88.4,11.7H87L84.61,3.14h1.32l1.41,5.19c0,.18.09.35.13.53a5,5,0,0,1,.12.53c0,.18.08.35.11.52s0,.32.08.47c0-.15,0-.32.08-.49s.07-.35.11-.53.08-.36.13-.53.09-.35.14-.51l1.58-5.18h1.29l1.64,5.21.15.52c0,.18.09.36.13.54s.07.35.11.51.06.32.08.46c0-.2.07-.41.11-.63s.1-.46.16-.71.11-.48.17-.71l1.41-5.19Z"
      />
      <path
        className="cls-1 tagline"
        d="M104.86,11.7h-1.29V7.75H99V11.7H97.73V3.14H99V6.71h4.55V3.14h1.29Z"
      />
      <path
        className="cls-1 tagline"
        d="M112.32,11.7h-5.18V3.14h5.18v1h-3.88V6.72h3.65v1h-3.65v2.93h3.88Z"
      />
      <path
        className="cls-1 tagline"
        d="M116.63,3.14a6.17,6.17,0,0,1,1.93.26,2.21,2.21,0,0,1,1.13.81,2.37,2.37,0,0,1,.37,1.38,2.11,2.11,0,0,1-.26,1.1,2.08,2.08,0,0,1-.67.74,3.79,3.79,0,0,1-.9.45l2.58,3.82h-1.49l-2.24-3.5h-1.7v3.5h-1.29V3.14Zm-.08,1h-1.17v3h1.26a2.53,2.53,0,0,0,1.59-.4,1.38,1.38,0,0,0,.51-1.17,1.25,1.25,0,0,0-.54-1.14A3.24,3.24,0,0,0,116.55,4.16Z"
      />
      <path
        className="cls-1 tagline"
        d="M127.32,11.7h-5.17V3.14h5.17v1h-3.88V6.72h3.65v1h-3.65v2.93h3.88Z"
      />
      <path
        className="cls-1 tagline"
        d="M131.31,3.14h2.86a5.84,5.84,0,0,1,2.85.52,1.76,1.76,0,0,1,.89,1.65,2,2,0,0,1-.39,1.26,1.61,1.61,0,0,1-1,.59v.06a2.05,2.05,0,0,1,1.27.68,2.13,2.13,0,0,1,.38,1.32,2.13,2.13,0,0,1-.91,1.83,4.21,4.21,0,0,1-2.47.65h-3.45Zm1.95,3.39h1.14a2.23,2.23,0,0,0,1.15-.23.83.83,0,0,0,.35-.75.75.75,0,0,0-.38-.71,2.72,2.72,0,0,0-1.23-.21h-1Zm0,1.44V10.2h1.28a2,2,0,0,0,1.19-.28,1,1,0,0,0,.38-.88c0-.71-.55-1.07-1.64-1.07Z"
      />
      <path className="cls-1 tagline" d="M139.89,11.7V3.14h2V11.7Z" />
      <path
        className="cls-1 tagline"
        d="M147.51,6.89h3.66v4.44a11,11,0,0,1-1.68.38,12.05,12.05,0,0,1-1.6.11,4.22,4.22,0,0,1-3.19-1.14,4.49,4.49,0,0,1-1.1-3.27,4.17,4.17,0,0,1,1.27-3.24A5.13,5.13,0,0,1,148.42,3a7.33,7.33,0,0,1,2.73.53L150.5,5a4.81,4.81,0,0,0-2.1-.47,2.69,2.69,0,0,0-2,.79,2.9,2.9,0,0,0-.76,2.12,3.24,3.24,0,0,0,.61,2.13,2.21,2.21,0,0,0,1.79.74,6.59,6.59,0,0,0,1.24-.12V8.41h-1.74Z"
      />
      <path className="cls-1 tagline" d="M155.72,11.7V3.14h2V11.7Z" />
      <path
        className="cls-1 tagline"
        d="M167.48,7.34a4,4,0,0,1-1.3,3.24,5.53,5.53,0,0,1-3.74,1.12h-2.61V3.14h2.89a5.1,5.1,0,0,1,3.51,1.11A3.9,3.9,0,0,1,167.48,7.34Zm-2,0c0-1.84-.88-2.76-2.63-2.76h-1V10.2h.84A2.49,2.49,0,0,0,165.45,7.39Z"
      />
      <path
        className="cls-1 tagline"
        d="M174.51,11.7H169.2V3.14h5.31V4.63h-3.36V6.51h3.13V8h-3.13v2.2h3.36Z"
      />
      <path
        className="cls-1 tagline"
        d="M182.31,11.7l-.67-2h-3.36l-.67,2H175.5l3.26-8.6h2.39l3.27,8.6Zm-1.14-3.56c-.61-1.85-1-2.89-1-3.13s-.13-.44-.17-.58c-.13.5-.53,1.74-1.19,3.71Z"
      />
      <path
        className="cls-1 tagline"
        d="M191.3,9.32a2.14,2.14,0,0,1-.9,1.83,4.08,4.08,0,0,1-2.5.67,6.3,6.3,0,0,1-2.61-.51V9.62a10.24,10.24,0,0,0,1.58.54,4.75,4.75,0,0,0,1.18.16,1.81,1.81,0,0,0,1-.23.76.76,0,0,0,.34-.68.74.74,0,0,0-.15-.45,1.68,1.68,0,0,0-.44-.37,11.65,11.65,0,0,0-1.2-.58,6.3,6.3,0,0,1-1.27-.71,2.79,2.79,0,0,1-.67-.79,2.13,2.13,0,0,1-.26-1.06,2.17,2.17,0,0,1,.83-1.79,3.68,3.68,0,0,1,2.3-.65,6.12,6.12,0,0,1,1.37.16,10.79,10.79,0,0,1,1.36.45L190.62,5a8.64,8.64,0,0,0-1.22-.39,3.91,3.91,0,0,0-1-.11,1.32,1.32,0,0,0-.85.24.75.75,0,0,0-.29.62.74.74,0,0,0,.12.42,1.19,1.19,0,0,0,.38.35,11.33,11.33,0,0,0,1.24.6,5,5,0,0,1,1.77,1.15A2.13,2.13,0,0,1,191.3,9.32Z"
      />
      <path
        className="cls-1 tagline"
        d="M201.48,11.7l-1-2.55h-3.61l-1,2.55h-1.34L198,3.1h1.32l3.5,8.6Zm-1.39-3.59-1-2.52c0-.09-.07-.22-.13-.39s-.12-.35-.19-.53-.11-.34-.14-.46c0,.16-.09.33-.15.51s-.11.34-.16.49-.1.28-.13.38l-1,2.52Z"
      />
      <path
        className="cls-1 tagline"
        d="M206.64,3.14a6.17,6.17,0,0,1,1.93.26,2.26,2.26,0,0,1,1.13.81,2.37,2.37,0,0,1,.37,1.38,2.21,2.21,0,0,1-.26,1.1,2.11,2.11,0,0,1-.68.74,3.79,3.79,0,0,1-.9.45l2.58,3.82h-1.48l-2.24-3.5h-1.7v3.5H204.1V3.14Zm-.08,1h-1.17v3h1.26a2.55,2.55,0,0,0,1.59-.4,1.38,1.38,0,0,0,.51-1.17,1.25,1.25,0,0,0-.54-1.14A3.24,3.24,0,0,0,206.56,4.16Z"
      />
      <path
        className="cls-1 tagline"
        d="M217.33,11.7h-5.18V3.14h5.18v1h-3.88V6.72h3.65v1h-3.65v2.93h3.88Z"
      />
      <path
        className="cls-1 tagline"
        d="M221.27,3.14h2.87a5.84,5.84,0,0,1,2.85.52,1.76,1.76,0,0,1,.89,1.65,2,2,0,0,1-.39,1.26,1.61,1.61,0,0,1-1,.59v.06a2,2,0,0,1,1.26.68,2.07,2.07,0,0,1,.39,1.32,2.13,2.13,0,0,1-.91,1.83,4.22,4.22,0,0,1-2.48.65h-3.45Zm2,3.39h1.13a2.2,2.2,0,0,0,1.15-.23.82.82,0,0,0,.36-.75.74.74,0,0,0-.39-.71,2.67,2.67,0,0,0-1.22-.21h-1Zm0,1.44V10.2h1.27a2,2,0,0,0,1.19-.28,1,1,0,0,0,.39-.88c0-.71-.55-1.07-1.64-1.07Z"
      />
      <path
        className="cls-1 tagline"
        d="M237.31,3.14V8.68a3,3,0,0,1-.46,1.66,2.88,2.88,0,0,1-1.32,1.1,5.14,5.14,0,0,1-2.05.38,4.09,4.09,0,0,1-2.76-.85,2.89,2.89,0,0,1-1-2.31V3.14h1.95V8.38a2,2,0,0,0,.43,1.45,2.33,2.33,0,0,0,2.81,0,2.14,2.14,0,0,0,.43-1.46V3.14Z"
      />
      <path className="cls-1 tagline" d="M239.41,11.7V3.14h2V11.7Z" />
      <path className="cls-1 tagline" d="M243.52,11.7V3.14h2V10.2h3.74v1.5Z" />
      <path
        className="cls-1 tagline"
        d="M253.39,11.7h-1.95v-7h-2.51V3.14h7V4.65h-2.51Z"
      />
      <line className="cls-2 line" x1="74.67" x2="74.67" y2="14.36" />
      <polygon
        className="cls-1"
        points="5.29 9.78 1.91 14.49 4.42 14.49 6.62 11.57 5.29 9.78"
      />
      <polygon
        className="cls-1"
        points="13.74 12.46 9.84 7.29 13.72 2.14 12.21 0.13 8.43 5.4 4.46 0.11 1.93 0.11 12.23 14.47 13.74 12.46"
      />
      <polygon
        className="cls-3"
        points="9.26 0.11 7.08 2.99 8.43 4.78 11.79 0.11 9.26 0.11"
      />
      <polygon
        className="cls-3"
        points="9.28 14.49 11.81 14.49 1.5 0.13 0 2.14 3.86 7.29 0 12.42 1.47 14.47 5.27 9.16 9.28 14.49"
      />
      <path
        className="cls-1"
        d="M17.25,11.69a4.12,4.12,0,0,1-4-2.74,4.66,4.66,0,0,1,.87-4.79,4,4,0,0,1,1.35-1,3.85,3.85,0,0,1,1.74-.35,4.12,4.12,0,0,1,3.11,1.33,4.4,4.4,0,0,1,.88,1.41,4.92,4.92,0,0,1,.31,1.7A4.85,4.85,0,0,1,21.24,9,4.35,4.35,0,0,1,19,11.34,4.51,4.51,0,0,1,17.25,11.69Zm-2.82-4.4a3.15,3.15,0,0,0,.23,1.25,2.89,2.89,0,0,0,.6,1,3.26,3.26,0,0,0,.89.67,2.57,2.57,0,0,0,2.2,0,2.82,2.82,0,0,0,.91-.69,2.86,2.86,0,0,0,.61-1,3.77,3.77,0,0,0,.22-1.24A3.23,3.23,0,0,0,19.87,6a4,4,0,0,0-.61-1,2.68,2.68,0,0,0-.91-.69,2.55,2.55,0,0,0-2.2,0,2.85,2.85,0,0,0-.89.69,2.88,2.88,0,0,0-.6,1A3.7,3.7,0,0,0,14.43,7.29Z"
      />
      <path
        className="cls-1"
        d="M35.27,11.52H33.84V6.75a3.5,3.5,0,0,0-.44-2,1.51,1.51,0,0,0-1.29-.65,2.36,2.36,0,0,0-1.57.63,3.52,3.52,0,0,0-1,1.62v5.14H28.11V6.75a3.73,3.73,0,0,0-.42-2,1.47,1.47,0,0,0-1.26-.63,2.37,2.37,0,0,0-1.56.61,3.25,3.25,0,0,0-1,1.64v5.14H22.42V3h1.31V4.84a3.7,3.7,0,0,1,1.35-1.45,3.42,3.42,0,0,1,1.86-.52,2.37,2.37,0,0,1,1.71.58,2.44,2.44,0,0,1,.76,1.49,3.55,3.55,0,0,1,3.24-2.07,2.39,2.39,0,0,1,1.23.27,2,2,0,0,1,.79.75A3.06,3.06,0,0,1,35.08,5a8.31,8.31,0,0,1,.13,1.41l.06,5.08Z"
      />
      <path
        className="cls-1"
        d="M40.54,11.69a4.23,4.23,0,0,1-1.76-.35,4.14,4.14,0,0,1-1.37-1A4.46,4.46,0,0,1,36.51,9a4.85,4.85,0,0,1,0-3.4,4.26,4.26,0,0,1,4-2.7,4.15,4.15,0,0,1,4,2.7,4.18,4.18,0,0,1,.29,1.64v.33c0,.08,0,.14,0,.23H37.7A3.15,3.15,0,0,0,38,8.93a2.7,2.7,0,0,0,.64.89,2.49,2.49,0,0,0,.89.58,2.45,2.45,0,0,0,1.06.21,3.32,3.32,0,0,0,.77-.1,3.65,3.65,0,0,0,.71-.29,3.54,3.54,0,0,0,.58-.44A1.69,1.69,0,0,0,43,9.2l1.25.35a3.48,3.48,0,0,1-.58.87,3.84,3.84,0,0,1-.86.69,4.07,4.07,0,0,1-1.07.46A8.13,8.13,0,0,1,40.54,11.69Zm2.93-5a3,3,0,0,0-.94-2,2.88,2.88,0,0,0-3-.56,2.74,2.74,0,0,0-.89.58,2.57,2.57,0,0,0-.62.87,3.26,3.26,0,0,0-.29,1.1Z"
      />
      <path
        className="cls-1"
        d="M50.28,11.09l-.34.16c-.14.07-.31.13-.47.19a4.91,4.91,0,0,1-.58.15,3.79,3.79,0,0,1-.67.06,2.14,2.14,0,0,1-1.35-.44,1.6,1.6,0,0,1-.58-1.33V4.13H45.13V3h1.16V.17h1.43V3h1.91V4.13H47.72V9.41a.87.87,0,0,0,.32.68,1,1,0,0,0,.64.21,2.07,2.07,0,0,0,.77-.15,1.84,1.84,0,0,0,.47-.22Z"
      />
      <path
        className="cls-1"
        d="M55.69,4.26a3.59,3.59,0,0,0-1.88.56,2.78,2.78,0,0,0-1.17,1.45v5.25H51.21V3h1.33V5A4.06,4.06,0,0,1,53.7,3.55a3,3,0,0,1,1.52-.62h.27a.55.55,0,0,1,.18,0l0,1.31Z"
      />
      <path
        className="cls-1"
        d="M58.08,13.14a3,3,0,0,0,.42,0l.33,0a.78.78,0,0,0,.75-.46,10.86,10.86,0,0,0,.49-1.23L56.48,3H58l2.9,7.23L63.5,3h1.37L61,13.06a2.47,2.47,0,0,1-.75,1,2.28,2.28,0,0,1-1.45.43,1.06,1.06,0,0,1-.31,0l-.38-.06Z"
      />
      <path
        className="cls-1"
        d="M62.34,11.77a.62.62,0,0,1,.31-.54.65.65,0,0,1,.31-.08.62.62,0,0,1,.62.62.55.55,0,0,1-.08.31.62.62,0,0,1-.54.32.61.61,0,0,1-.54-.32A.55.55,0,0,1,62.34,11.77Zm.1,0a.51.51,0,0,0,.51.52h0a.41.41,0,0,0,.26-.07.44.44,0,0,0,.19-.19.52.52,0,0,0,0-.52.58.58,0,0,0-.19-.19.53.53,0,0,0-.52,0,.58.58,0,0,0-.19.19A.48.48,0,0,0,62.44,11.77Zm.77-.14a.18.18,0,0,1-.13.19l.21.33h-.18L63,11.86h-.08v.29h-.15V11.4h.21a.25.25,0,0,1,.2.06A.21.21,0,0,1,63.21,11.63Zm-.34.11h.06a.14.14,0,0,0,.09,0,.08.08,0,0,0,0-.08.07.07,0,0,0,0-.08.14.14,0,0,0-.09,0h-.06Z"
      />
    </svg>
  );
};
